import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createTopic,
  getTopicList,
  getTopic,
  updateTopic,
  deleteTopic,
} from '../../api/topicApi.js';

import { createMessage } from '../../api/messagesApi.js';
import toast from 'react-hot-toast';
import { sendWSData } from '../../api/websocketApi.js';

export const newTopic = createAsyncThunk(
  'letters/newTopic',
  async (userData, thunkAPI) => {
    try {
      const result = await createTopic(userData);
      return result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const rewriteTopic = createAsyncThunk(
  'letters/rewriteTopic',
  async (userData, thunkAPI) => {
    try {
      const result = await updateTopic(userData);
      return result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const fetchTopicList = createAsyncThunk(
  'letters/fetchTopicList',
  async (userData, thunkAPI) => {
    try {
      const result = await getTopicList(userData);
      return result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const fetchTopic = createAsyncThunk(
  'letters/fetchTopic',
  async (userData, thunkAPI) => {
    try {
      const result = await getTopic(userData);
      return result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const removeTopic = createAsyncThunk(
  'letters/removeTopic',
  async (userData, thunkAPI) => {
    try {
      const result = await deleteTopic(userData);
      return result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const createFirstMessage = createAsyncThunk(
  'letters/createFirstMessage',
  async (userData, thunkAPI) => {
    try {
      const topicPromise = createTopic(userData.topic);
      const topic = await toast.promise(topicPromise, {
        loading: 'Wait. Your mail is creating',
        success: 'Great! You mail has been sent!',
        error: 'Ups. Something went wrong.',
      });
      const messageData = {
        message: {
          ...userData.message,
          chatId: topic._id,
        },
        users: [userData.recipient],
        type: 'newLetter',
        updateTopic: true,
      };
      const messagePromise = createMessage(messageData);
      const message = await toast.promise(messagePromise, {
        loading: 'Wait. You are redirecting to your mail list',
        success: 'Here is list of mails.',
        error: 'Ups. Something went wrong.',
      });
      sendWSData({
        users: messageData.users,
        action: 'newLetter',
        data: message,
      });
      updateTopic({
        topicId: topic._id,
        data: {
          lastMessage: message,
        },
      });
      return {
        topic: {
          ...topic,
          lastMessage: message,
        },
        message,
      };
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const replyMessage = createAsyncThunk(
  'letters/replyMessage',
  async (userData, thunkAPI) => {
    try {
      const message = await createMessage({ ...userData, updateTopic: true });
      updateTopic({
        topicId: message.chatId,
        data: {
          lastMessage: message,
        },
      });

      return message;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
